export class AffectedConditionsByMove {
  constructor(
    public other: string[] = [],
    public current: string[] = [],
    public blocks: { blockId: string; questionId: string }[] = []
  ) {}

  get apply(): boolean {
    return this.other.length > 0 || this.current.length > 0 || this.blocks.length > 0;
  }
}
